"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.poll = void 0;
const wait_js_1 = require("./wait.js");
function poll(fn, _ref) {
  let {
    emitOnBegin,
    initialWaitTime,
    interval
  } = _ref;
  let active = true;
  const unwatch = () => active = false;
  const watch = async () => {
    var _await$initialWaitTim;
    let data = undefined;
    if (emitOnBegin) data = await fn({
      unpoll: unwatch
    });
    const initialWait = (_await$initialWaitTim = await (initialWaitTime === null || initialWaitTime === void 0 ? void 0 : initialWaitTime(data))) !== null && _await$initialWaitTim !== void 0 ? _await$initialWaitTim : interval;
    await (0, wait_js_1.wait)(initialWait);
    const poll = async () => {
      if (!active) return;
      await fn({
        unpoll: unwatch
      });
      await (0, wait_js_1.wait)(interval);
      poll();
    };
    poll();
  };
  watch();
  return unwatch;
}
exports.poll = poll;
//# sourceMappingURL=poll.js.map